import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  CreateFinanceManualPayload,
  FinanceManualMarketingDashboardDto,
  FinanceManualTableDto,
  FinanceManualTableQuery,
} from '../../../models/finance/finance-manual-list.model';

@Injectable({ providedIn: 'root' })
export class ApiFinanceManualService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getFinanceManualForTable(query: FinanceManualTableQuery): Observable<FinanceManualTableDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = {
      siteId: query.siteId,
      userId: query.userId,
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };

    if (query.searchField) params['searchField'] = query.searchField;
    if (query.searchText) params['searchText'] = query.searchText;
    if (query.startDate) params['startDate'] = query.startDate;
    if (query.endDate) params['endDate'] = query.endDate;
    if (query.feeType) params['feeType'] = query.feeType;
    if (query.feeName) params['feeName'] = query.feeName;
    if (query.minFee && query.minFee > 0) params['minFee'] = query.minFee;

    return this.apiMethodService.request<FinanceManualTableDto>(
      '/Backoffice/getFinanceManualForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getFinanceManualForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getFinanceManualMarketingDashboard(
    siteId: number,
    userId: number,
    startDate?: string,
    endDate?: string
  ): Observable<FinanceManualMarketingDashboardDto> {
    const token = this.cookieService.get('token');
    const params: Record<string, string | number> = { siteId, userId };
    if (startDate) params['startDate'] = startDate;
    if (endDate) params['endDate'] = endDate;

    return this.apiMethodService.request<FinanceManualMarketingDashboardDto>(
      '/Backoffice/getFinanceManualMarketingDashboard',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getFinanceManualMarketingDashboard',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  createFinanceManual(payload: CreateFinanceManualPayload): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/Backoffice/CreateTheFinanceManual',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'CreateTheFinanceManual',
        token,
        headerOnly: false,
        body: payload,
      }
    );
  }

  getFinanceManualById(financeId: number, siteId: number, userId: number): Observable<unknown> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<unknown>(
      '/Backoffice/getFinanceManualById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getFinanceManualById',
        token,
        headerOnly: false,
        params: { financeId, siteId, userId },
      }
    );
  }

  /** ไฟล์แนบของ parking_finance (รูปใบเสร็จ / หลักฐานการโอน) */
  getFinanceAttachments(financeId: number, siteId: number, userId: number): Observable<unknown> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<unknown>(
      '/Backoffice/getFinanceAttachments',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: false,
        labelLog: 'getFinanceAttachments',
        token,
        headerOnly: false,
        params: { financeId, siteId, userId },
      }
    );
  }
}
